import { Badge, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Flex, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useNavigationType } from 'react-router-dom';
import { PiPlusBold } from 'react-icons/pi';
import Confirmation from './Confirmation';
import Stock from './Stock';
import Suivi from './Suivi';
import { useStateContext } from '../../../../context/ContextProvider';
import Facture from './Facture';

function MyOrders() {
    const navigate = useNavigate()
    const navType = useNavigationType()
    const { t } = useTranslation();
    const { user, dataSubscriptionUser } = useStateContext()

    const [tabIndex, setTabIndex] = useState(() => {
        if (navType !== 'POP') {
            sessionStorage.removeItem('MyOrders_tabIndex');
        }
        const saved = sessionStorage.getItem('MyOrders_tabIndex');
        return saved ? parseInt(saved, 10) : 0;
    });

    const handleTabsChange = (index) => {
        setTabIndex(index);
        sessionStorage.setItem('MyOrders_tabIndex', index);
    };

    return (
        <Box position="relative" mb={5}>

            {/* <Flex zIndex={999} position={"fixed"} bottom={10} right={5}>
                <Button

                    onClick={() => {
                        navigate("/NewOrder")
                    }}
                    colorScheme='purple'
                >
                    <PiPlusBold size={18} />

                </Button>
            </Flex> */}

            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Breadcrumb  fontStyle={"normal"} fontSize={{ base: "14px", sm: "14px", lg: "15px" }} color="gray.400" letterSpacing="-0.01em">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Mes commandes")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>

                    <Flex align="center" gap={5} direction="row" justify="end">
                        {
                            dataSubscriptionUser?.message === 'Client has no active subscription' ?
                                <Badge colorScheme='red'
                                    rounded="xl"
                                    title={t("Pas d'abonnement actif")}
                                    px={2}>
                                    {t("Pas d'abonnement actif")} !
                                </Badge>
                                :
                                dataSubscriptionUser?.subscription?.demande || !dataSubscriptionUser?.subscription?.is_active
                                    ?
                                    <>
                                        {dataSubscriptionUser?.subscription?.demande
                                            &&
                                            <Badge colorScheme='red'
                                                rounded="xl"
                                                title={t("Votre abonnement n'est pas encore accepté")}
                                                px={2}>
                                                {t("Abonnement en attente")}
                                            </Badge>}

                                        {!dataSubscriptionUser?.subscription?.demande && !dataSubscriptionUser?.subscription?.is_active
                                            &&
                                            <Badge colorScheme='red'
                                                rounded="xl"
                                                title={t("Votre abonnement est désactivé")}
                                                px={2}>
                                                {t("Abonnement désactivé")}
                                            </Badge>}
                                    </>
                                    :
                                    <Badge colorScheme={parseInt(dataSubscriptionUser?.orders_limit) !== 0 && parseInt(dataSubscriptionUser?.subscription?.orders_count) >= parseInt(dataSubscriptionUser?.orders_limit) ? 'red' : 'green'}
                                        rounded="xl"
                                        title={parseInt(dataSubscriptionUser?.orders_limit) !== 0 && parseInt(dataSubscriptionUser?.subscription?.orders_count) >= parseInt(dataSubscriptionUser?.orders_limit) ? t('Vous avez atteint la limite de commandes pour votre abonnement') : t("Nombre de commandes restantes")}
                                        px={2}>
                                        {dataSubscriptionUser?.subscription?.orders_count} / {parseInt(dataSubscriptionUser?.orders_limit) === 0 ? t('Illimité') : dataSubscriptionUser?.orders_limit} {t('commandes')}
                                    </Badge>
                        }
                    </Flex>
                </Box>

            </Flex>

            <Stack>
                <Tabs isLazy index={tabIndex} onChange={handleTabsChange}>
                    <TabList>
                        <Tab>
                            <Text fontSize={{ base: 12, lg: 15 }}>{t("Confirmation")}</Text>
                        </Tab>
                        <Tab>
                            <Text fontSize={{ base: 12, lg: 15 }}>{t("Stock")}</Text>
                        </Tab>
                        <Tab>
                            <Text fontSize={{ base: 12, lg: 15 }}>{t("Suivi")}</Text>
                        </Tab>
                        <Tab>
                            <Text fontSize={{ base: 12, lg: 15 }}>{t("Facture")}</Text>
                        </Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel>
                            {user && <Confirmation user={user} dataSubscriptionUser={dataSubscriptionUser} />}
                        </TabPanel>
                        <TabPanel>
                            <Stock />
                        </TabPanel>
                        <TabPanel>
                            <Suivi />
                        </TabPanel>
                        <TabPanel>
                            <Facture />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Stack>
        </Box>
    )
}

export default MyOrders